import React from "react";
import { Link } from "react-router-dom";

/**
 * Cocoon Medical Spa brand mark.
 * Renders the golden butterfly logo from /brand/cocoon-logo.png.
 * Variants:
 *  - "full"  → logo + subtle wordmark stack (default landing)
 *  - "mark"  → logo only (for nav bars)
 *  - "row"   → small logo + "Cocoon Medical Spa" text next to it
 */
export default function Logo({ variant = "mark", to = "/", className = "", size = 40, testid = "brand-logo" }) {
  const img = (
    <img
      src="/brand/cocoon-logo.png"
      alt="Cocoon Medical Spa"
      style={{ height: size, width: "auto" }}
      className="object-contain select-none"
      draggable={false}
    />
  );

  let inner;
  if (variant === "full") {
    inner = (
      <div className="flex flex-col items-center">
        <img
          src="/brand/cocoon-logo.png"
          alt="Cocoon Medical Spa"
          style={{ height: size * 1.4 }}
          className="object-contain"
          draggable={false}
        />
      </div>
    );
  } else if (variant === "row") {
    inner = (
      <div className="flex items-center gap-2">
        {img}
        <span className="font-editorial text-lg leading-none tracking-tight hidden sm:inline">Cocoon Medical Spa</span>
      </div>
    );
  } else {
    inner = img;
  }

  if (!to) return <span className={className} data-testid={testid}>{inner}</span>;
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid={testid}>
      {inner}
    </Link>
  );
}
